import React from 'react';
import { Image } from 'react-bootstrap';
import logo from './logo-programa-Primero-LEE-alta.png';

const MainLogo = props => <Image src={logo} alt="Logo" className="d-inline-block align-top" {...props} />;

export default MainLogo;
